import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsWrapper() {
  const location = useLocation();

  // Carrega o script do GA com atraso para evitar prejudicar a performance
  useEffect(() => {
    const timer = setTimeout(() => {
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-D3SQ5R9J1C";
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag("js", new Date());
        gtag("config", "G-D3SQ5R9J1C", {
          page_path: location.pathname,
          send_page_view: false, // controlamos manualmente o envio
        });
      };
    }, 2000); // aguarda 2 segundos após o carregamento

    return () => clearTimeout(timer);
  }, []);

  // Envia evento a cada mudança de rota, se o GA já tiver carregado
  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-D3SQ5R9J1C", {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null; // componente não renderiza nada visível
}
